import { formatCollaboratorNameAndRegistration, formatInstantDateToPtBR } from '@/shared/lib';
import type { InfoDocumento } from '@/shared/lib';
import type {
  RejectedMatrixDecision,
  RejectedMatrixDetailResponse,
  RejectedMatrixMember,
} from '../api/matrices.api';

export const REJECTED_STATUS_LABEL = 'Registro reprovado';

const formatMember = (member: RejectedMatrixMember | null | undefined): string =>
  formatCollaboratorNameAndRegistration(member?.name, member?.registrationNumber);

const formatRevision = (revision: number | null): string =>
  revision === null ? '-' : String(revision).padStart(2, '0');

export function buildElaborationInfo(record: RejectedMatrixDetailResponse): InfoDocumento[] {
  return [
    { label: 'Data da solicitação', value: formatInstantDateToPtBR(record.requestedAt) },
    { label: 'Registro', value: record.code },
    { label: 'Título', value: record.title },
    { label: 'Revisão', value: formatRevision(record.revision) },
    { label: 'Colaborador', value: formatMember(record.elaboration) },
  ];
}

export function buildApprovalStageInfo(record: RejectedMatrixDetailResponse): InfoDocumento[] {
  if (record.rejectedStage === 'APPROVAL') {
    return buildRejectedDecisionInfo('Aprovação', record.approval);
  }

  return [
    { label: 'Data da Aprovação', value: formatInstantDateToPtBR(record.approval?.date) },
    { label: 'Aprovação', value: formatMember(record.approval?.member) },
  ];
}

export function buildVerificationStageInfo(record: RejectedMatrixDetailResponse): InfoDocumento[] {
  return buildRejectedDecisionInfo('Verificação', record.verification);
}

function buildRejectedDecisionInfo(
  decisionLabel: string,
  decision: RejectedMatrixDecision | null
): InfoDocumento[] {
  return [
    { label: 'Data', value: formatInstantDateToPtBR(decision?.date) },
    { label: decisionLabel, value: formatMember(decision?.member) },
    { label: 'Status', value: REJECTED_STATUS_LABEL },
  ];
}
